var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8292 3.63962C41.8292 3.63962 39.7183 5.72474 36.7563 6.10007C36.7563 6.10007 32.092 -0.280495 25.4189 5.26604C22.4228 7.8516 22.1505 13.3148 22.6611 15.2748C22.6611 15.2748 13.6049 16.1505 5.70611 4.80734C5.70611 4.80734 2.16532 12.3139 8.02122 18.3191C8.02122 18.3191 6.29042 18.6527 4.64517 16.9847C4.64517 16.9847 3.86753 24.7414 10.9492 26.91C10.9492 26.91 10.4726 27.9109 7.61267 26.91C7.61267 26.91 8.08929 33.2488 14.8304 34.1663C14.8304 34.1663 11.1887 38.7536 3 38.1698C3 38.1698 16.5328 50.5974 31.1727 35.5843C39.3438 27.0769 39.0714 14.8162 38.9352 12.9813C38.9352 12.9813 42.1621 9.97865 43 8.06028C43 8.06028 40.5014 9.06115 38.4586 9.06115C38.4586 9.06095 41.1823 7.30942 41.8292 3.63962V3.63962Z",
    stroke: "white",
    strokeWidth: 4.06613,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.44d02d5252aa1b403aae4305a660b2f2.svg";
export { ForwardRef as ReactComponent };